import { render, staticRenderFns } from "./exportblk4c.vue?vue&type=template&id=58bca72c"
import script from "./exportblk4c.vue?vue&type=script&lang=js"
export * from "./exportblk4c.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports